export default __webpack_public_path__ + "static/media/epitettEsTermeszetiOrokseg.52e9ddff.png";